import {
  Box,
  Container,
  Divider,
  Flex,
  HStack,
  Text,
  Link,
  Image,
  Icon,
  VStack,
} from "@chakra-ui/react"
import { Link as RouterLink } from "react-router-dom"
import { FaFacebookSquare, FaInstagram } from "react-icons/fa"
import { getComponent } from "../../../brandConfig"

export const FooterWithFourColumns = () => {
  return (
    <Box
      bg={getComponent("footer", "bg")}
      color="white"
      py={12}
      mt="auto"
    >
      <Container maxW="1200px">
        <VStack spacing={8}>
          {/* Top Section - Logo and Social */}
          <Flex
            direction={{ base: "column", md: "row" }}
            width="full"
            justify="space-between"
            align="center"
            gap={8}
          >
            {/* Logo */}
            <Box>
              <Link as={RouterLink} to="/">
                <Image
                  src="/assets/onesolarimages/one-stop-solar-darklogo.webp"
                  alt="One Solar"
                  height="100px"
                  width="auto"
                  objectFit="contain"
                />
              </Link>
            </Box>

            {/* Follow and Social Icons */}
            <VStack align={{ base: "center", md: "flex-end" }} spacing={2}>
              <Text fontSize="md" fontWeight="600">
                Follow ONE SOLAR
              </Text>
              <HStack spacing={4}>
                <Link
                  href="https://www.facebook.com/share/14NK1QCPNc1/?mibextid=wwXIfr"
                  target="_blank"
                  _hover={{ opacity: 0.8 }}
                >
                  <Icon as={FaFacebookSquare} boxSize={6} />
                </Link>
                <Link
                  href="https://www.instagram.com/one_solar_nz?igsh=MXRlZDZ1Mmx2dnByeA%3D%3D&utm_source=qr"
                  target="_blank"
                  _hover={{ opacity: 0.8 }}
                >
                  <Icon as={FaInstagram} boxSize={6} />
                </Link>
              </HStack>
            </VStack>
          </Flex>

          {/* Divider */}
          <Divider
            borderColor="rgba(255, 255, 255, 0.2)"
            display={{ base: "none", md: "block" }}
          />

          {/* Middle Section - Links and License */}
          <Flex
            direction={{ base: "column", md: "row" }}
            width="full"
            justify="space-between"
            gap={8}
          >
            {/* Left Column - Links */}
            <HStack
              spacing={0}
              flexWrap="wrap"
              fontSize="sm"
              fontWeight="500"
              textTransform="uppercase"
              justify={{ base: "center", md: "flex-start" }}
            >
              <Link
                as={RouterLink}
                to="/charli-cannon-sponsor"
                _hover={{ opacity: 0.8 }}
              >
                SPONSOR
              </Link>
              <Text mx={2} color="white">|</Text>
              <Link
                as={RouterLink}
                to="/capability"
                _hover={{ opacity: 0.8 }}
              >
                CAPABILITY STATEMENT
              </Link>
              <Text mx={2} color="white">|</Text>
              <Link
                as={RouterLink}
                to="/privacy-policy"
                _hover={{ opacity: 0.8 }}
              >
                PRIVACY POLICY
              </Link>
              <Text mx={2} color="white">|</Text>
              <Link
                as={RouterLink}
                to="/promotion-conditions"
                _hover={{ opacity: 0.8 }}
              >
                PROMOTIONAL TERMS & CONDITIONS
              </Link>
            </HStack>

            {/* Right Column - License and Copyright */}
            <VStack
              align={{ base: "center", md: "flex-end" }}
              spacing={1}
              fontSize="md"
            >
              <Text>© 2024 All Rights Reserved.</Text>
            </VStack>
          </Flex>

          {/* Divider */}
          <Divider borderColor="rgba(255, 255, 255, 0.2)" />

          {/* Bottom Section - Disclaimer */}
          <Box width="full">
            <Text
              fontSize="sm"
              textAlign="left"
              lineHeight="1.8"
              color="rgba(255, 255, 255, 0.9)"
            >
              <Text as="span" fontWeight="bold">One Solar New Zealand Limited</Text> (Company Number: 9372605) is a registered New Zealand company committed to delivering innovative and sustainable solar energy solutions across residential, commercial, and rural properties throughout New Zealand. We specialize in high-quality solar installations, maintenance, and monitoring services, helping Kiwi families and businesses reduce their energy costs and environmental impact.
            </Text>
          </Box>
        </VStack>
      </Container>
    </Box>
  )
}